import { Column } from "@ant-design/plots";

import { useGraphTheme } from "../../../hooks/useGraphTheme";

const AnalyticsGenericBarGraph = ({
  dataPoints = [],
  xAxisFieldName = "date",
  yAxisFieldName = "value",
  userSuppliedConfig = {}
}) => {
  const graphTheme = useGraphTheme();

  // Configuration options for the double column bar graph
  const config = {
    data: dataPoints || [],
    xField: xAxisFieldName,
    yField: yAxisFieldName,
    ...graphTheme,
    ...userSuppliedConfig
  };

  return <Column {...config} />;
};

export default AnalyticsGenericBarGraph;
